import { Api } from "@/Instructure/configs/api";
import BaseRepository from "../Base/BaseRepository";
import IFoodRepository from "./IFoodRepository";

export default class FoodRepository extends BaseRepository implements IFoodRepository {

  private dateTime = new Date().getTime().toString()

  async getMenu() {
    const data = await this.CreateRequestBuilder()
      .setMothod("get")
      .setUrl(Api.Food.getMenu)
      .addQueryParam("nocache", this.dateTime)
      .GetResultAsync();
    return data
  }

  async getInfo() {
    return await this.CreateRequestBuilder()
      .setMothod("get")
      .setUrl(Api.Food.getInfo)
      .addQueryParam("nocache", this.dateTime)
      .GetResultAsync();
  }
}
